import SearchInput from './components/index.vue';

SearchInput.install = function(Vue) {
  Vue.component(SearchInput.name, SearchInput)
}

export default SearchInput
